import { User } from '../Interfaces';
import { baseUrl, usersUrl } from '../config';

export const getUser = async (id: string | undefined , token: string):Promise<User> => {
  return new Promise((resolve, reject) => {
      fetch(baseUrl + 'Users/' + id, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response.json());
      }).catch(error => {
        reject(error)
      }
  )})
}


export const getUsers = async (token: string):Promise<User[]> => {
    return new Promise((resolve, reject) => {
        fetch(baseUrl + 'Users/withobjects', {
          method: 'GET',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (!response.ok) {
            // If response status is not in the success range (200-299), reject with the error text
                  return response.text().then(errorText => {
                    reject(errorText);
                  });
                }
          resolve(response.json());
        }).catch( () => {
          reject('Unexpected error')
        }
    )})
  }



  export const  addOrUpdateUser = async ( data: User, token: string):Promise<string> => {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    let requestOptions:any =  {}
    let bUrl = ''
    if(data.id !== undefined) {
       requestOptions = {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(data)
        };
        bUrl = usersUrl + data.id
    }
    else {
      requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      };
      bUrl = usersUrl
    }

    return new Promise((resolve, reject) => {
        fetch(bUrl, requestOptions)
          .then( response => {
            if (!response.ok) {
          // If response status is not in the success range (200-299), reject with the error text
                  return response.text().then(errorText => {
                    try {
                      const errRes:any = JSON.parse(errorText)
                      console.log('errRes', errRes)

                      reject(errRes[0]?.description);
                    }
                    catch (err) {
                      reject(errorText.toString());
                    }
                  });
              }
              resolve ('Die Änderungen wurden erfolgreich gespeichert')
            }
          ).catch( (error) => {
            reject(error + 'Fehler beim Hinzufügen oder Aktualisieren von Benutzern' )
          });
    })
  }

/* eslint-disable  @typescript-eslint/no-explicit-any */

  export const deleteUser = async ( userId: string | undefined, token: string):Promise<string> => {
    let requestOptions:any =  {}
    let bUrl = ''
       requestOptions = {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        };
        bUrl = usersUrl + userId
    return new Promise((resolve, reject) => {
        fetch(bUrl, requestOptions)
          .then( response => {
            if (!response.ok) {
          // If response status is not in the success range (200-299), reject with the error text
                return response.text().then(errorText => {
                  reject(errorText);
                });
              }
              resolve (`The user is successfully removed`)
            }
          ).catch( (error) => {
            reject(error + 'Error on deleting the user' )
          });
    })
  }


  export const resetPassword = async ( userId: string | undefined, newPasssword: string, token: string):Promise<string> => {

    //if(userId === undefined) return Promise.reject('No User ID sent');
console.log('restpass', token)
    let requestOptions:any =  {}
    let bUrl = ''
    const data = {
      userId: userId,
      newPassword: newPasssword
    }
       requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(data)
        };
        bUrl = usersUrl + 'resetpassword'
    return new Promise((resolve, reject) => {
        fetch(bUrl, requestOptions)
          .then( response => {
            if (!response.ok) {
          // If response status is not in the success range (200-299), reject with the error text
                return response.text().then(errorText => {
                  reject(errorText);
                });
              }
              resolve (`Das Passwort wurde erfolgreich geändert`)
            }
          ).catch( (error) => {
            reject(error + 'Fehler beim Ändern des Benutzerkennworts' )
          });
    })
  }